<template>
  <div class="footer">
    <h4 class="info">2017 © Xbed Sci-tech Information Service Co.,Ltd.</h4>
  </div>
</template>

<script>
export default {

}
</script>



// WEBPACK FOOTER //
// src/components/footer.vue